import { memo } from "react";
import { Outlet } from "infrastructure/router";

const Onboarding = () => (
    <>
        <Outlet />
        {/* <Navigate
            replace
            to={WebRoutes.Onboarding.Applications.Index}
        /> */}
    </>
);

export default memo(Onboarding);
